//https://api.dev.livingpackets.com/v3/shipment/inspection/tickets/{ticket_id}

import { useMutation } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig, queryClient } from '@/lib/react-query';

export const patchInspection =
  (makeRequest: any) =>
  async ({
    note,
    close,
    ticketId,
  }: {
    close?: boolean;
    note?: string;
    ticketId: string;
  }): Promise<any> => {
    const { error, data } = await makeRequest({
      path: `/inspection/tickets/${ticketId}`,
      method: 'patch',
      body: {
        ...(close ? { close: true } : {}),
        ...(note ? { note } : {}),
      },
    });

    if (error) {
      throw error;
    }

    return data;
  };

type UsePatchInspectionOptions = {
  config?: MutationConfig<ReturnType<typeof patchInspection>>;
};

export const usePatchInspection = ({ config }: UsePatchInspectionOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('shipmentV3');

  return useMutation({
    ...config,
    mutationFn: patchInspection(makeRequest),
    onSuccess: (data) => {
      queryClient.setQueryData(['patchInspection', data.ticket_id], data);
    },
  });
};
